<template>
	<div class="app-header">
        <h3 class="app-header__name">{{ page }}</h3>

        <div class="app-header__avatar">
            <AppImage
                :src="require('@/assets/img/default-avatar.png')"
                title="avatar"
                class="avatar"
                @click="showUserMenu = !showUserMenu"
            />

            <p
                v-if="showUserMenu"
                class="app-header__logout"
                @click="logout()"
                v-on-clickaway="() => showUserMenu = !showUserMenu"
            >
                Logout
            </p>
        </div>

	</div>
</template>

<script>
import AppImage from '@/components/AppImage'

export default {
	props: {
		page: String
	},
	data () {
		return {
			showUserMenu: false
		}
	},

	methods: {
		logout () {
			this.$store.dispatch('logout')
			this.$router.go()
		}
	},
	components: {
		AppImage
	}
}
</script>

<style lang="scss" scoped>
.app-header {
	color: $default;
	padding: 10px 20px;
	display: flex;
    align-items: center;
    height: 80px;

	&__name {
		flex: 1 1 auto;
        font-size: 1.6em;
        color: #647286;
        font-family: 'Quicksand', sans-serif;
        font-weight: 600;
	}

	&__icon, &__arrow {
		margin: 0 1em;
		cursor: pointer;
	}

	&__icon {
		height: 2em;
	}

	&__arrow {
		width: 1em;
	}

	&__logo {
		width: 2.5em;
		margin-right: 2em;
	}

    &__avatar {
		position: relative;
		margin-left: 1em;

		.avatar {
			cursor: pointer;
			border-radius: 50%;
			width: 2em;
			height: 2em;
			background-size: cover;
		}
	}

    &__logout {
		position: absolute;
		top: 100%;
		right: 0;
		margin-top: 10px;
		background-color: #fff;
		padding: 10px 20px;
		color: $dark;
		cursor: pointer;
		border: 1px solid $light;
		border-radius: 5px;
		z-index: 999;

		&:after {
			position: absolute;
			content: "";
			right: .5em;
			top: -6px;
			border: 1px solid;
			border-color: $light  $light transparent transparent;
			display:inline-block;
			height: 10px;
			width: 10px;
			background-color: #fff;
			transform: rotateZ(-45deg);
			pointer-events: none;
			z-index: 999;
		}

		&:hover {
			color: $primary;
			border-color: $primary;

			&:after {
				border-color: $primary $primary transparent transparent;
			}
		}
	}
}
</style>
